import { Dialog, DialogContent } from '@/components/atoms';
import { REFERRAL_SHARE_MESSAGE } from '../constants';
import {
  buildInstagramShareUrl,
  buildSmsShareUrl,
  buildWhatsAppShareUrl,
} from '../utils';
import { Info, MessageCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import { useState } from 'react';

interface ShareSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  referralLink: string;
}

const howItWorksSteps = [
  'Share your unique link',
  'Friend signs up and sells',
  'You earn monthly for 6 months as they sell',
];

export const ShareSheet = ({
  open,
  onOpenChange,
  referralLink,
}: ShareSheetProps) => {
  const [copied, setCopied] = useState(false);
  const message = `${REFERRAL_SHARE_MESSAGE} ${referralLink}`;

  const copyLink = async () => {
    await navigator.clipboard.writeText(referralLink);
    setCopied(true);
    toast.success('Referral link copied');
    setTimeout(() => setCopied(false), 1800);
  };

  const openShare = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="refer-earn-page max-w-xl gap-0 overflow-hidden border-0 p-0">
        <div className="share-modal">
          <div className="share-h">
            <h3 className="rne-h2" style={{ fontSize: 20 }}>
              Share your referral link
            </h3>
          </div>

          <div className="share-b">
            <div className="share-section">
              <div className="share-lbl">Copy Link</div>
              <div className="share-link-row">
                <input
                  className="share-link-input"
                  value={referralLink}
                  readOnly
                  onFocus={(event) => event.target.select()}
                />
                <button
                  type="button"
                  className="share-copy-btn"
                  onClick={copyLink}
                >
                  {copied ? 'Copied' : 'Copy'}
                </button>
              </div>
            </div>

            <button
              type="button"
              className="share-wa-btn"
              onClick={() => openShare(buildWhatsAppShareUrl(referralLink))}
            >
              <MessageCircle className="size-5" />
              Share to WhatsApp
            </button>

            <div className="share-channels">
              <button
                type="button"
                className="share-ch"
                onClick={() => openShare(buildInstagramShareUrl(referralLink))}
              >
                Instagram
              </button>
              <button
                type="button"
                className="share-ch"
                onClick={() => openShare(buildSmsShareUrl(referralLink))}
              >
                SMS
              </button>
              <button type="button" className="share-ch" onClick={copyLink}>
                Copy Link
              </button>
            </div>

            <div>
              <div className="share-preview-tag">PREVIEW</div>
              <div className="share-preview-box">&ldquo;{message}&rdquo;</div>
            </div>

            <div className="share-how">
              <div className="share-how-h">
                <Info className="size-4 text-[#22B573]" />
                <span>How it works</span>
              </div>
              <div className="share-how-grid">
                {howItWorksSteps.map((step, index) => (
                  <div key={step} className="share-step">
                    <div className="share-step-n">{index + 1}</div>
                    <div className="share-step-l">{step}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
